import { useMutation } from "@apollo/client";
import { useJsonForms, withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { LoadingSpinner } from "pepsico-ds";
import { useEffect } from "react";
import { countProfilesBySegments } from "../../../graphql/mutations/countProfilesBySegments";

// This component is only setting value of total_unique_users
// based on the segments selected in CampaignSegmentSelectControl

const TotalUniqueSegmentUsers = (props) => {
  const { handleChange, path } = props;
  const ctx = useJsonForms();
  const [callCountProfileBySegments, { loading }] = useMutation(
    countProfilesBySegments,
    {
      onCompleted: (data) => {
        const totalUniqueUsers = data.countProfilesBySegments.totalUniqueActiveUsers;
        handleChange(path, totalUniqueUsers);
        return null;
      },
    }
  );

  useEffect(() => {
    const segments = ctx.core.data?.segment_ids || [];
    if (segments.length > 0) {
      callCountProfileBySegments({
        variables: {
          filter: {
            segments: segments,
          },
        },
      });
    } else {
      handleChange(path, 0); // Reset to 0 if no segments are selected
    }
  }, [ctx.core.data?.segment_ids, callCountProfileBySegments, handleChange, path]);

  if (loading) {
    return (
      <div data-testid="loading-indicator">
        <LoadingSpinner size={{ height: 24, width: 24 }} />
      </div>
    );
  }

  return null; // This component does not render anything
};

export const TotalUniqueSegmentUsersControl = withJsonFormsMultiEnumProps(
  TotalUniqueSegmentUsers
);
